import { useSelector } from 'react-redux';

export const useCurrentLnsUser = (): $Lns.User => {
  const { currentLnsUser } = useSelector(
    (state: $Lns.DefaultState) => state.default
  );

  return currentLnsUser;
};
